import classnames from 'classnames';
import React, { PropsWithChildren, useRef } from 'react';
import { useModalStore } from '~/stores/modal';

import CloseButton from './CloseButton';
import Overlay from './Overlay';

const CSS = require('./Modal.module.scss');

interface ModalProps {
  show: boolean;
  onClose: () => void;
  className?: string;
  overlayClassName?: string;
  portalId?: string;
  fullscreen?: boolean;
  hideClose?: boolean;
}

const Modal = ({
  show,
  onClose,
  overlayClassName,
  fullscreen,
  className,
  hideClose,
  portalId,
  children,
}: PropsWithChildren<ModalProps>) => {
  const container = useRef(null);
  const modal = useModalStore((state) => state.modal);
  const closeModal = () => {
    if (!!onClose && show) {
      onClose();
    }
  };

  const modalClick = (event) => {
    event.nativeEvent.stopImmediatePropagation();
    event.stopPropagation();

    if (!modal && !container.current.contains(event.target)) {
      closeModal();
    }
  };

  if (!show) {
    return null;
  }

  return (
    <Overlay
      onEsc={closeModal}
      className={classnames(overlayClassName, {
        [CSS.RemoveOverlayBackground]: fullscreen,
      })}
      onClick={modalClick}
      portalId={portalId || 'dialogPortal'}
    >
      <dialog
        ref={container}
        className={classnames(CSS.Modal, {
          [className]: className,
          [CSS.ModalFullscreen]: fullscreen,
        })}
      >
        {!hideClose && <CloseButton onClick={closeModal} />}
        {children}
      </dialog>
    </Overlay>
  );
};

export default Modal;
